import { WorkspaceLoginConfigQueryType } from '@lucidlink/dto/validation';
import { InvitationInfoResponseDto, UserGuestConfigResponseDto, UserLoginConfigResponseDto, WorkspaceLoginConfigResponseDto, } from '@lucidlink/dto/web-service-api';
import { parserFromDto } from '#fetcher/parse-utils';
export const createPublicClient = ({ getUnauthenticatedFetcher, }) => {
    return new PublicClientImpl(getUnauthenticatedFetcher);
};
export class PublicClientImpl {
    getUnauthenticatedFetcher;
    constructor(getUnauthenticatedFetcher) {
        this.getUnauthenticatedFetcher = getUnauthenticatedFetcher;
    }
    async checkServiceStatus() {
        await this.getUnauthenticatedFetcher().get(['service-status']);
    }
    getInvitationInfo(invitationId) {
        return this.getUnauthenticatedFetcher().get(['invitations', invitationId, 'info'], { parser: parserFromDto(InvitationInfoResponseDto) });
    }
    getWorkspaceLoginConfigByName(workspaceName) {
        return this.doGetWorkspaceLoginConfig(WorkspaceLoginConfigQueryType.NAME, workspaceName);
    }
    getWorkspaceLoginConfigById(workspaceId) {
        return this.doGetWorkspaceLoginConfig(WorkspaceLoginConfigQueryType.ID, workspaceId);
    }
    listPreconfiguredSubscriptions() {
        return this.getUnauthenticatedFetcher().get('config');
    }
    getUserLoginConfig(email, workspaceName) {
        return this.getUnauthenticatedFetcher().get([
            'user-login-config',
            encodeURIComponent(email),
            ...(workspaceName ? ['workspace', workspaceName] : []),
        ], {
            parser: parserFromDto(UserLoginConfigResponseDto),
        });
    }
    /**
     * @deprecated
     *
     * Use: `getGuestConfig`
     *
     * Date: 2026-05-06
     */
    async legacyGetGuestConfig(email, workspaceId) {
        return this.getUnauthenticatedFetcher().get([
            'workspaces',
            workspaceId,
            'guest-config',
            encodeURIComponent(email),
        ], {
            parser: parserFromDto(UserGuestConfigResponseDto),
        });
    }
    getGuestConfig(email, linkId) {
        return this.getUnauthenticatedFetcher().get([
            'user-login-config',
            encodeURIComponent(email),
            'guest-link',
            linkId,
        ], {
            parser: parserFromDto(UserLoginConfigResponseDto),
        });
    }
    doGetWorkspaceLoginConfig(queryType, queryValue) {
        return this.getUnauthenticatedFetcher().get(['workspace-login', 'config'], {
            queryParams: {
                queryType,
                queryValue,
            },
            parser: parserFromDto(WorkspaceLoginConfigResponseDto),
        });
    }
}
